import { render, staticRenderFns } from "./CostSaving.vue?vue&type=template&id=1ab8a662&scoped=true"
import script from "./CostSaving.vue?vue&type=script&lang=js"
export * from "./CostSaving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab8a662",
  null
  
)

export default component.exports